import React from 'react'
import styled from 'styled-components'
import Table, { TableRow, TableRowCell } from 'core-system/Table'
import Text from 'core-system/Text'
import SecondaryButton from 'core-system/Button/SecondaryButton'
import palette from 'core-system/Themes/palette'
import { PayCadenceResponse } from '../payCadenceService'

const EmptyTableRow = styled(TableRow)`
  pointer-events: none;
`

const ActionButtons = styled.div`
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
`

interface PayCadenceTableProps {
  cadences: PayCadenceResponse[]
  groupsLabelById: Record<string, string>
  frequencyLabelById: Record<string, string>
  scheduleLabelById: Record<string, string>
  onEdit: (cadence: PayCadenceResponse) => void
  onDelete: (cadence: PayCadenceResponse) => void
  isDeletingId?: string | null
}

const PayCadenceTable = ({
  cadences,
  groupsLabelById,
  frequencyLabelById,
  scheduleLabelById,
  onEdit,
  onDelete,
  isDeletingId,
}: PayCadenceTableProps) => {
  const rows =
    cadences.length === 0
      ? [
          <EmptyTableRow key='empty'>
            <TableRowCell colSpan={5}>
              <Text variant='body2' textColor={palette.text.secondary}>
                No pay schedules yet. Add one to get started.
              </Text>
            </TableRowCell>
          </EmptyTableRow>,
        ]
      : cadences.map((cadence) => (
          <TableRow key={cadence.id}>
            <TableRowCell>{cadence.name || 'Pay schedule'}</TableRowCell>
            <TableRowCell>{groupsLabelById[cadence.id] ?? '—'}</TableRowCell>
            <TableRowCell>{frequencyLabelById[cadence.id] ?? '—'}</TableRowCell>
            <TableRowCell>{scheduleLabelById[cadence.id] ?? '—'}</TableRowCell>
            <TableRowCell>
              <ActionButtons>
                <SecondaryButton onClick={() => onEdit(cadence)}>Edit</SecondaryButton>
                <SecondaryButton
                  onClick={() => onDelete(cadence)}
                  disabled={isDeletingId === cadence.id}
                >
                  Delete
                </SecondaryButton>
              </ActionButtons>
            </TableRowCell>
          </TableRow>
        ))

  return (
    <Table
      headers={[
        <TableRowCell key='name'>Name</TableRowCell>,
        <TableRowCell key='groups'>Worksites / Groups</TableRowCell>,
        <TableRowCell key='frequency'>Frequency</TableRowCell>,
        <TableRowCell key='schedule'>Pay schedule</TableRowCell>,
        <TableRowCell key='actions'>Actions</TableRowCell>,
      ]}
      rows={rows}
    />
  )
}

if (process.env.NODE_ENV !== 'production') {
  PayCadenceTable.displayName = 'PayCadenceTable'
}

export default React.memo(PayCadenceTable)
